import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';

const createOrgDocs = async (value) => {
  return await request.post(`/Docs/orgs`, value, '', 'Error');
};

const useCreateOrgDocs = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation(createOrgDocs, {
    onSuccess: async (data, { serviceCompanyId }) => {
      if (data === 'Error') return;

      queryClient.invalidateQueries(queryKeys.orgsDocs(serviceCompanyId));
    },
  });

  return {
    isLoading: mutation.isLoading,
    createOrgDocs: mutation.mutateAsync,
  };
};

export default useCreateOrgDocs;
